import { SxProp } from 'src/types/mui';

export const rowStyles: SxProp = {
  '& > *': { borderBottom: '1px solid #D0D1D9 !important' },
};

export const rowEmployerStyles: SxProp = {
  '& > *': { borderBottom: '1px solid #D0D1D9 !important' },
  backgroundColor: '#F0F0F5',
};

export const arrowStyles: SxProp = {
  width: '40px',
  maxWidth: '40px',
  minWidth: '40px',
  paddingLeft: 0,
};

export const labelStyles: SxProp = {
  display: 'flex',
  alignItems: 'center',
};

export const logoStyles: SxProp = {
  marginRight: '15px',
};

export const nameStyles: SxProp = {
  fontWeight: 'bold',
};

export const searchStyles: SxProp = {
  width: '320px',
};
